<template>
    <print-container>
        <div v-for="(liga, i) in rundeLigaArray" :key="i"
             :class="[{'pageBreak': i%2 !== 0 }]">
            <div class="text-center title mb-2" v-if="i%2 === 0">
                <div class="text-center title mt-10 mb-2" >{{header}}</div>
                <div class="text-center subtitle-1 px-3 pb-2 my-0 font-weight-medium">{{subheader}}</div>
            </div>
            <spiele-liste :headers="headersRunde" :spiele="liga" hide-default-footer type="runde"
                          :search="searchAll" :no-actions="true" class="mb-7">
            </spiele-liste>
        </div>
    </print-container>
</template>

<script>
    import PrintContainer from "./printContainer";
    import SpieleListe from "../spieleListe";

    export default {
        components: {
            SpieleListe,
            PrintContainer },
        name: "print-spiele",
        computed: {
            header(){return this.$store.state.local.printContainer.header},
            subheader(){return this.$store.state.local.printContainer.subheader},
            headersRunde(){return this.$store.state.local.printContainer.content.headersRunde},
            rundeLigaArray(){return this.$store.state.local.printContainer.content.rundeLigaArray},
            searchAll(){return this.$store.state.local.printContainer.content.searchAll},
        },
    }
</script>

<style scoped>
</style>